module.exports = __webpack_public_path__ + "img/speed-5.e59899ea.png";